const ObservationsToggleNoneOption = (options = {}) => {
  const _defaults = {
    noneToggle: '.js-toggle-none-option',
    medicalToggles: '.js-toggle-medical-option'
  };

  const settings = { ..._defaults, ...options };

  let noneToggle, medicalToggles;

  // Deselect medical options (Uncheck them)
  const deselectMedicalOptions = () => {
    if (!medicalToggles) return;
    const otherInput = document.querySelector('.js-toggle');

    // Trigger change event when Other option is unchecked
    if(otherInput && otherInput.checked) {
      otherInput.dispatchEvent(new Event('change'));
    }

    medicalToggles.forEach((toggle) => {
      toggle.checked = false;
    });
  };

  // Deselect the "None" option
  const deselectNoneOption = () => {
    if (!noneToggle) return;

    noneToggle.checked = false;
  };

  // Public: Initialise module
  const init = () => {
    noneToggle = document.querySelector(settings.noneToggle);
    medicalToggles = document.querySelectorAll(settings.medicalToggles);

    if (!noneToggle || !medicalToggles) return;

    // Attach event listeners
    noneToggle.addEventListener('click', deselectMedicalOptions);
    medicalToggles.forEach((toggle) => {
      toggle.addEventListener('click', deselectNoneOption);
    });
  };

  // Public: Remove event listeners
  const destroy = () => {
    if (noneToggle) {
      noneToggle.removeEventListener('click', deselectMedicalOptions);
      medicalToggles.forEach((toggle) => {
        toggle.removeEventListener('click', deselectNoneOption);
      });
    }
  };

  // Public: Reinitialise the module (destroy then init)
  const reinit = () => {
    destroy();
    init();
  };

  return {
    init,
    destroy,
    reinit,
  };
};

export default ObservationsToggleNoneOption;
